import { render, staticRenderFns } from "./DeliveryReportDetail.vue?vue&type=template&id=b8b300a8"
import script from "./DeliveryReportDetail.vue?vue&type=script&lang=js"
export * from "./DeliveryReportDetail.vue?vue&type=script&lang=js"
import style0 from "./DeliveryReportDetail.vue?vue&type=style&index=0&id=b8b300a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports